import { Button, Menu, MenuItem, SxProps, Theme, Tooltip } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { MoreVert } from '@mui/icons-material';
import styles from './MenuButton.module.css';

interface MenuOption {
  handler?: () => void;
  item: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
  label?: string;
}

interface MenuButtonProps {
  buttonStyles?: SxProps<Theme>;
  children?: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
  options?: MenuOption[];
  tooltipLabel?: string;
}

//  TODO: make element controlled (add an open: Boolean prop).
const MenuButton: React.FC<MenuButtonProps> = ({ buttonStyles, children, options, tooltipLabel }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderElement = (element: string | JSX.Element | JSX.Element[] | (() => JSX.Element)) => {
    if (typeof element === 'function') return element();
    return element;
  };

  return (
    <Fragment>
      <Tooltip title={tooltipLabel} arrow>
        <Button
          id='menu-button'
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          disableRipple
          sx={buttonStyles}
          className={styles.menuButton}
        >
          {children ? renderElement(children) : <MoreVert />}
        </Button>
      </Tooltip>
      <Menu
        id='menu-button'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={{
          'aria-labelledby': 'menu-button',
        }}
      >
        {options?.map(({ item, handler }, index) => {
          return (
            <div key={`menu-item-${index}`}>
              <MenuItem
                key={`menu-item-${index}`}
                sx={{ width: '264px' }}
                onClick={() => {
                  if (handler) handler();
                  handleClose();
                }}
              >
                {renderElement(item)}
              </MenuItem>
              {index !== options.length - 1 && <hr style={{ margin: ' 0 16px' }} />}
            </div>
          );
        })}
      </Menu>
    </Fragment>
  );
};

export default MenuButton;
